import { t } from '@transifex/native';

import { flashes } from 'pkg/actions';
import * as endpoints from 'pkg/api/endpoints/auto';
import * as sdk from 'pkg/core/sdk';
import { crash } from 'pkg/errors/errors';

export async function remove(
	organizationId: number,
	id: number,
	deleteEvent = true
) {
	const q: { [key: string]: string } = {};

	if (deleteEvent) {
		q.deleteEvent = 'true';
	}

	const req = await sdk.destroy(
		endpoints.Bookings.Delete(organizationId, id),
		q
	);

	if (!req.ok) {
		flashes.show({
			title: crash().title,
		});

		return false;
	}

	flashes.show({
		title: t('Successfully removed booking'),
	});

	return true;
}
